// @ts-strict-ignore
import { useMutation } from '@tanstack/react-query'
import { postRefundFeeEstimate } from 'services/RefundService'
import { BaseErrorResponse } from 'types/beneficiaries'
import { RefundFeePayload } from 'types/refund'
import { logSentryError } from 'utils/sentry'

export const useRefundFeeEstimateMutation = () => {
  return useMutation({
    mutationFn: postRefundFeeEstimate,
    onError: (error: BaseErrorResponse, data: RefundFeePayload) => {
      logSentryError('Error: useRefundFeeEstimateMutation', error, data)
    },
  })
}
